import {
  SearchPageTemplateTestResult,
  SearchPageTemplateVariant,
  SearchPageTemplateTestData,
} from "./types";
import { useMonarchRule } from "../MonarchRulesProvider";

const CUSTOM_RULE_ID = "searchPageRedesign";

const useSearchPageTemplate = (): SearchPageTemplateTestResult => {
  const { isLoading, value } = useMonarchRule<{
    data: SearchPageTemplateTestData;
    variantCustomId: string;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading || !value) {
    return {
      isLoading,
    } as SearchPageTemplateTestResult;
  }

  // Determine the variant from the Monarch API response
  let variant: SearchPageTemplateVariant = "control";
  if (
    value.data.pageDesign === "verticalFilterV2" ||
    value.data.pageDesign === "horizontalFilterV1"
  ) {
    variant = value.data.pageDesign;
  }

  return {
    isLoading: false,
    variant,
    data: value.data,
  };
};

export default useSearchPageTemplate;
